const forms_types = {
  login: {
    email: "VALIDATE_LOGIN_EMAIL",
    password: "VALIDATE_LOGIN_PASSWORD",
    form: "VALIDATE_LOGIN_FORM"
  }
}

export default forms_types



// WEBPACK FOOTER //
// ./src/js/constants/formsTypes.js